// Interruption parsing at the boundary (FR-2.5): a refused turn request's
// typed failure → the interruption kind the transcript shows. The durable
// kinds (stopped, recorded errors, unfinished turns) are parsed from the log
// in conversationAdapter; this is the client-only half. Pure, total.

import { exhaustSwitchCase } from "@bilda/utils";
import type { SystemEntryKind } from "../components/Chat/types.js";
import type { ExternalError } from "./externalError.js";

// A refused request never reached the turn, so nothing of it was recorded.
export const interruptionOfRefusal = (e: ExternalError): SystemEntryKind => {
    switch (e._tag) {
        case "External.Unreachable":
        case "External.AgentUnreachable":
            return { type: "connection_lost", messageSaved: false };
        case "External.Unauthorized":
            return { type: "signed_out" };
        case "External.QuotaExhausted":
            return { type: "budget_used_up" };
        case "External.Unknown":
            return { type: "unknown", cause: e.detail ?? e._tag };
        case "External.Forbidden":
        case "External.PrivacyTermsNotAccepted":
        case "External.RateLimited":
        case "External.Rejected":
        case "External.Refused":
        case "External.Upstream":
        case "External.Malformed":
        case "External.AgentAuthMissing":
        case "External.AgentBusy":
        case "External.AgentFailed":
            return { type: "failed", error: e };
        default:
            return exhaustSwitchCase(e);
    }
};
